import type { LocaleResources } from '../types';

/**
 * Trigger settings UI string resources
 * signal-trigger, trailing, overlapping, exclusive, etc.
 */
export const triggerStr: LocaleResources['triggerStr'] = {
  title: {
    unsavedChanges: '[{type}] Unsaved Changes',
  },
  message: {
    unsavedConfirm: 'You have unsaved changes. Do you want to save?',
    ratioSum100: 'The sum of entry quantity ratios must be 100%.',
    noSelectedSignalType: 'No signal type selected.',
    noSelectedCondition: 'No condition selected.',
    strategyUpdated: 'Strategy {name} has been updated.',
    roeCannotBeZero: 'ROE cannot be 0.',
  },
  header: {
    signal: 'Signal',
    dropRatio: 'Drop Rate from High',
    riseRatio: 'Rise Rate from Low',
    evalDropRatio: 'Drop Rate from Max Eval Seed',
    exitRatio: '{type} Ratio',
    amountRatio: '{type} Amount Ratio',
    remaining: '(of remaining)',
    roePercent: 'ROE (+/-)',
    total: 'Total',
  },
  label: {
    belowWhen: 'when falling below',
    aboveWhen: 'when rising above',
    below: ' or below',
    above: ' or above',
    fallingWhen: 'On {type}',
    risingWhen: 'On {type}',
  },
  validation: {
    selectSignal: 'Please select a signal.',
    greaterThanZero: 'Please enter a number greater than 0.',
    positiveNumber: 'Please enter a positive number.',
    nonZeroNumber: 'Please enter a non-zero number.',
  },
};
